import React, { useState } from 'react';
import { Title, useTranslate } from 'react-admin';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Badge from '@mui/material/Badge';

import HomeTab from './tabs/HomeTab';
import QuestsTab from './tabs/QuestsTab';
import StatsTab from './tabs/StatsTab';
import useQuests from './useQuests';


const TabPanel = ({ children, value, index, ...props }) => (
    <Box role="tabpanel" hidden={value !== index} {...props}>
        {value === index && <Box>{children}</Box>}
    </Box>
);

const Dashboard = () => {
    const [currentTab, setCurrentTab] = useState(0);
    const translate = useTranslate();
    const quests = useQuests();

    const handleChangeTab = (e, value) => {
        setCurrentTab(value);
    };

    const renderQuestTabLabel = () => (
        <Badge badgeContent={quests?.unfinishedQuestCount} color="warning">
            <Box pr={1.5}>{translate('Quests')}</Box>
        </Badge>
    );

    return (
        <Box sx={{ marginBottom: '30px' }}>
            <Title title="Kernel" />
            <Tabs value={currentTab} onChange={handleChangeTab}>
                <Tab label={translate('Home')} />
                <Tab label={renderQuestTabLabel()} />
                <Tab label={translate('Stats')} />
            </Tabs>
            <TabPanel value={currentTab} index={0}>
                <HomeTab {...quests} />
            </TabPanel>
            <TabPanel value={currentTab} index={1}>
                <QuestsTab quests={quests} />
            </TabPanel>
            <TabPanel value={currentTab} index={2}>
                <StatsTab />
            </TabPanel>
        </Box>
    );
};

export default Dashboard;